import React, { useContext } from "react";
import { FlexContainer, mobile, tablet, TextLabel } from "src/components";
import { ActionButton } from "./style";
import styled from "styled-components";
import Email from "src/img/email.svg";
import { EmailCampaignsContext } from "../EmailCampaignsContext";
import { SubscriptionMode } from "src/constants/userDetails";

const ProgressContainer = styled.div`
    width: ${(p) => p.width || "381px"};
    height: 18px;
    background: #F3F5FB;
    border-radius: 9px;
    box-shadow: none;
    overflow: hidden;
    border: 1px solid #D8DEEC;
    ${mobile`
        width: ${p => p.mWidth || "100%"};
    `};

    ${tablet`
        width: ${p => p.tWidth || "100%"};
    `};
`;

// Dynamic progress bar
const ProgressBar = styled.div`
    height: 100%;
    width: ${(p) => p.progress || 0}%;
    background: linear-gradient(270deg, #26A26B 0%, #171A22 100%);
    border-radius: 9px 0 0 9px;
    transition: width 0.3s ease-in-out; /* smooth animation */
`;

const PurchasedBadge = styled.div`
    width: 142px;
    box-shadow: none;
    border: 1px solid #D8DEEC;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #171A22;
    font-weight: 600;
    font-size: 14px;
`;

function EmailStatistics() {
    const {
        user,
        initialStatistics,
        toggleEmailPackages,
        purchasedEmailPro,
        packages
    } = useContext(EmailCampaignsContext);

    const percentageUsed = Math.floor(100 * initialStatistics.monthlyCapConsumed / initialStatistics.monthlyCap);
    const sendsRemaining = initialStatistics.monthlyCap - initialStatistics.monthlyCapConsumed;
    const audienceBreakdown = initialStatistics.audienceBreakdown;

    const freePackage = packages?.find(pkg => pkg.price === 0);
    const purchasedPackage =
        packages?.find(pkg => pkg.uuid === purchasedEmailPro?.addonUuid)
        || packages?.find(pkg => pkg.uuid === purchasedEmailPro?.uuid)
        || freePackage;

    return (
        <FlexContainer
            border="1px solid #D8DEEC"
            minHeight="205px"
            borderRadius="16px"
            marginBottom="20px"
            style={{ boxShadow: "0 18px 36px rgba(29, 42, 89, 0.08)" }}
            color="#FFFFFF"
        >
            <FlexContainer
                color="#FFFFFF"
                justifyContent="space-between"
                direction="row"
                height="71px"
                borderRadius="16px 16px 0px 0px"
                alignItems="center"
                padding="25px"
                tDirection="row"
                style={{ borderBottom: "1px solid #D8DEEC" }}
            >
                <FlexContainer direction="row" tDirection="row" mDirection="row" justifyContent="center" alignItems="center" gap="10px">
                    <img src={Email} width="25" height="25" />
                    <TextLabel color="#171A22" weight={700}>Email Sending Overview</TextLabel>
                </FlexContainer>
                {user.subscriptionMode === SubscriptionMode.ACTIVE &&
                    <FlexContainer direction="row" tDirection="row" gap="10px">
                        {purchasedPackage && <PurchasedBadge>{purchasedPackage.title}</PurchasedBadge>}
                        <ActionButton
                            width="184px"
                            height="39px"
                            color="#FFFFFF"
                            background="#171A22"
                            border="2px solid #171A22"
                            onClick={toggleEmailPackages}
                        >
                        Upgrade to Email Pro
                        </ActionButton>
                    </FlexContainer>
                }
            </FlexContainer>
            <FlexContainer
                direction="row"
                alignItems="center"
                height="100%"
                padding="15px"
                gap="10px"
                wrap="wrap"
            // justifyContent="space-evenly"
            >
                <FlexContainer
                    direction="column"
                    alignItems="flex-start"
                    minWidth="425px"
                    width="415px"
                    height="101px"
                    border="1px solid #D8DEEC"
                    borderRadius="12px"
                    justifyContent="space-between"
                    color="#FFFF"
                    padding="17px"
                    tWidth="100%"
                    style={{ boxShadow: "0px 5px 5px #0000001A" }}
                >
                    <FlexContainer
                        direction="row"
                        tDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                        tWidth="100%"
                    >
                        <FlexContainer>
                            <TextLabel weight="700" color="#171A22">
                                Monthly Send Usage
                            </TextLabel>
                            <FlexContainer direction="row" tDirection="row">
                                <TextLabel margin="0px 5px 0px 0px" weight="900">
                                    {percentageUsed}%
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px">
                                    Used -
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px" weight="900">
                                    {sendsRemaining}
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px">
                                    Sends Remaining
                                </TextLabel>
                            </FlexContainer>
                        </FlexContainer>
                        <TextLabel color="#171A22" size="30px" weight="900">
                            {initialStatistics.monthlyCapConsumed}/{initialStatistics.monthlyCap}
                        </TextLabel>
                    </FlexContainer>
                    <ProgressContainer>
                        <ProgressBar progress={Math.min(percentageUsed, 100)} />
                    </ProgressContainer>
                </FlexContainer>
                <FlexContainer
                    direction="column"
                    alignItems="flex-start"
                    minWidth="275px"
                    width="275px"
                    height="101px"
                    border="1px solid #D8DEEC"
                    borderRadius="12px"
                    justifyContent="center"
                    padding="17px"
                    tWidth="100%"
                    color="#FFFF"
                    style={{ boxShadow: "0px 5px 5px #0000001A" }}
                >
                    <FlexContainer
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                    >
                        <FlexContainer>
                            <TextLabel weight="700" color="#171A22">
                                Audience Breakdown
                            </TextLabel>
                            <FlexContainer direction="row" tDirection="row">
                                <TextLabel margin="0px 5px 0px 0px" weight="700">
                                    {audienceBreakdown.businessUsers ?? 0}
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px">Me Business Users</TextLabel>
                            </FlexContainer>
                            <FlexContainer direction="row" tDirection="row">
                                <TextLabel margin="0px 5px 0px 0px" weight="700">
                                    {audienceBreakdown.importedContacts}
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px">Imported Contacts</TextLabel>
                            </FlexContainer>
                        </FlexContainer>
                    </FlexContainer>
                </FlexContainer>
                <FlexContainer
                    direction="column"
                    alignItems="flex-start"
                    minWidth="275px"
                    width="275px"
                    height="101px"
                    border="1px solid #D8DEEC"
                    borderRadius="12px"
                    justifyContent="center"
                    padding="17px"
                    tWidth="100%"
                    color="#FFFF"
                    style={{ boxShadow: "0px 5px 5px #0000001A" }}
                >
                    <FlexContainer
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                    >
                        <FlexContainer>
                            <TextLabel weight="700" color="#171A22">
                                Engagement
                            </TextLabel>
                            <FlexContainer direction="row" tDirection="row">
                                <TextLabel margin="0px 5px 0px 0px" weight="700">
                                    {initialStatistics.deliveryRate}
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px">Delivery Rate</TextLabel>
                            </FlexContainer>
                            <FlexContainer direction="row" tDirection="row">
                                <TextLabel margin="0px 5px 0px 0px" weight="700">
                                    {initialStatistics.openRate}
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px">Open</TextLabel>
                                <TextLabel margin="0px 5px 0px 0px" weight="700">
                                    {initialStatistics.clickRate}
                                </TextLabel>
                                <TextLabel margin="0px 5px 0px 0px">Clicks</TextLabel>
                            </FlexContainer>
                        </FlexContainer>
                    </FlexContainer>
                </FlexContainer>
            </FlexContainer>
        </FlexContainer>
    );
}

export default EmailStatistics;
